import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import * as instructorActions from "../../_actions/roster.actions";
import dates from "react-big-calendar/lib/utils/dates";
import LeaveHeaderMonth from "./LeaveHeaderMonth";
import TimeGutter from "react-big-calendar/lib/TimeGutter";
import moment from "moment";
import memoize from "memoize-one";
import Resources from "react-big-calendar/lib/utils/Resources";
import getWidth from "dom-helpers/width";
import LeaveDayColumn from "./LeaveDayColumn";
import ResourceList from "./ResourceList";

class LeaveReportContents extends Component {
  constructor(props) {
    super(props);
    this.state = { gutterWidth: undefined, isOverflowing: null };
    this.gutterRef = React.createRef();
    this.scrollRef = React.createRef();
  }

  static defaultProps = {
    step: 60,
    timeslots: 1,
    min: dates.startOf(new Date(), "day"),
    max: dates.endOf(new Date(), "day"),
    scrollToTime: dates.startOf(new Date(), "day"),
    getNow: () => new Date()
  };

  componentDidMount = () => {
    this.measureGutter();
    // initialize displayWeeklyEvents
    // let cond = {};
    // cond.view = "work";
    // this.props.actions.updateWeeklyReportEvents(cond);
  };

  componentWillReceiveProps = () => {
    this.measureGutter();
  };

  measureGutter() {
    // let node = findDOMNode(this.gutterRef.current);
    let node = document.getElementById("resourceList");
    const width = getWidth(node);

    if (width && this.state.gutterWidth !== width) {
      this.setState({ gutterWidth: width });
    }
  }

  memoizedResources = memoize((resources, accessors) =>
    Resources(resources, accessors)
  );

  handleScroll = e => {
    if (this.scrollRef.current) {
      this.scrollRef.current.scrollLeft = e.target.scrollLeft;
    }
  };

  renderEvents(range, events, now) {
    let { min, max, components, localizer } = this.props;

    return range.map((date, idx) => {
      let daysEvents = events.filter(
        event =>
          dates.inRange(event.start, date, date, "day") ||
          dates.inRange(event.end, date, date, "day")
      );

      return (
        <LeaveDayColumn
          {...this.props}
          localizer={localizer}
          min={dates.merge(date, min)}
          max={dates.merge(date, max)}
          components={components}
          isNow={dates.eq(date, now(), "day")}
          key={idx}
          date={date}
          daysEvents={daysEvents}
          employees={this.props.employees}
        />
      );
    });
  }

  render() {
    let { localizer, range, getNow } = this.props;

    const eventsList = _.map(this.props.events, (obj, key) => {
      return obj;
    });

    return (
      <div>
        <div className="rbc-time-view">
          <LeaveHeaderMonth
            range={range}
            localizer={localizer}
            width={120}
            getNow={this.props.getNow}
            scrollRef={this.scrollRef}
            isOverflowing={false}
          />

          <div
            ref="content"
            className="rbc-time-content"
            onScroll={this.handleScroll}
          >
            <ResourceList employees={this.props.employees} />
            {this.renderEvents(range, eventsList, getNow)}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.employeeLeave.leaves,
    branches: state.BranchReducer.branchList,
    departments: state.DepartmentReducer.departmentList
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(instructorActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaveReportContents);
